


























































import { Component, Mixins } from 'vue-property-decorator';
import MultiSelect from 'vue-multiselect';
import MessageMethods from '@/mixins/MessageMethods.vue';
import ConversationListItem from '@/components/Admin/MessageSystem/Conversation/ConversationListItem.vue';
import BaseDropDown from '@/components/DropDowns/BaseDropDown.vue';
import ConversationData from '@/ts/ConversationData';
import { Actions, Mutations } from '@/ts/store/Constants';

@Component({
    components: {
        MultiSelect,
        ConversationListItem,
        BaseDropDown,
    },
})
export default class ConversationList extends Mixins(MessageMethods) {
    public searchFieldFocused: boolean = false;
    public showConversationTypesDropDown: boolean = false;

    constructor() {
      super();
    }

    get selectedConversationType(): string {
        return this.$store.getters['Messages/getVisibleConversationsStatus'];
    }

    get conversationTypes(): any {
        const canReadAllMessages = this.userHasAccessTo('corporation-messages-management');
        const conversationTypes = [
            { text: this.$t('messages.open-conversations', 'Open conversations'), value: 'open' },
            { text: this.$t('messages.closed-conversations', 'Closed conversations'), value: 'closed' }
        ];

        if (canReadAllMessages) {
           conversationTypes.push({ text: this.$t('messages.all-conversations', 'All conversations'), value: 'all' });
        }

        return conversationTypes;
    }

    get searchClasses() {
        return {
            'hoc-search-expanded': (this.searchFieldFocused === true || this.messageSearchTerms.length > 0),
        };
    }

    public changeConversationStatus(type: string) {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_VISIBILITY, false);
        this.$store.commit(Mutations.SET_VISIBLE_CONVERSATIONS_STATUS, type);

        switch (type) {
            case 'open':
                this.$store.commit(Mutations.SET_ACTIVE_OPEN_CONVERSATIONS);
                break;
            case 'closed':
                this.$store.commit(Mutations.SET_ACTIVE_CLOSE_CONVERSATIONS);
                break;
            case 'all':
                this.$store.commit(Mutations.SET_ACTIVE_EXTERNAL_CONVERSATIONS);
                break;
            default:
                this.$store.commit(Mutations.SET_ACTIVE_OPEN_CONVERSATIONS);
                break;
        }

        this.showConversationTypesDropDown = false;
    }

    public handleSearchFocus(event: Event) {
        this.searchFieldFocused = true;
    }

    public handleSearchBlur(event: Event) {
        this.searchFieldFocused = false;
    }

    public setActiveConversation(conversation: ConversationData) {
        this.$store.commit(Mutations.SET_TICKET_CREATE_FORM_VISIBILITY, false);
        this.$store.commit(Mutations.UPDATE_ACTIVE_CONVERSATION, conversation.id);

        if (conversation.hasUnseenMessages === true) {
            this.$store.dispatch(Actions.MARK_ACTIVE_CONVERSATION_AS_SEEN);
        }
    }

    public showAddConversationDialog(): void {
        this.$store.commit(Mutations.SET_ADD_CONVERSATION_DIALOG_VISIBILITY, true);
    }

    public userHasAccessTo(feature: string) {
        if (this.$store.getters['User/getUser'] === null) {
            return false;
        }

        return this.$store.getters['User/getUser'].hasAccessTo(feature);
    }

    public created() {
        switch (this.selectedConversationType) {
            case 'open':
                this.$store.commit(Mutations.SET_ACTIVE_OPEN_CONVERSATIONS);
                break;
            case 'closed':
                this.$store.commit(Mutations.SET_ACTIVE_CLOSE_CONVERSATIONS);
                break;
            case 'all':
                this.$store.commit(Mutations.SET_ACTIVE_EXTERNAL_CONVERSATIONS);
                break;
            default:
                this.$store.commit(Mutations.SET_ACTIVE_OPEN_CONVERSATIONS);
                break;
        }
    }

}
